import { Link, Navigate, useNavigate } from "react-router-dom";
import { LogOut, History, X, Heart, Star } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang, LANGUAGES } from "@/lib/i18n";
import { METRIC, unitPref, setUnitPref } from "@/lib/units";
import { BigTextRow } from "@/components/BigTextRow";
import { WaterLimit } from "@/components/WaterLimit";
import { AskDev } from "@/components/AskDev";
import { QuestionInbox } from "@/components/QuestionInbox";
import { ReviewInbox } from "@/components/reviews/ReviewInbox";

export default function AccountPage() {
  const { user, signOut } = useAuth();
  const { lang, setLang, t } = useLang();
  const nav = useNavigate();
  if (user === false) return <Navigate to="/" replace />;
  return (
    <div className="screen" data-testid="account-screen">
      <header className="sites-header">
        <div><div className="header-title">{t("Account")}</div><div className="header-sub">{user?.email}</div></div>
        <button type="button" className="header-btn" data-testid="account-close" aria-label={t("Close")}
          onClick={() => (window.history.state?.idx > 0 ? nav(-1) : nav("/"))}><X size={20} /></button>
      </header>
      <div className="screen-body">
        <div className="card account-card">
          {user?.picture && <img src={user.picture} alt="" className="avatar-lg" />}
          <div className="card-name" data-testid="account-name">{user?.name}</div>
          {user?.is_supporter && <div className="supporter-badge" data-testid="supporter-badge"><Heart size={13} fill="currentColor" />{t("Supporter")}</div>}
          <div className="card-sub">{user?.email}</div>
        </div>
        <div className="card">
          <div className="label">{t("Language")}</div>
          <select className="text-input load-select" value={lang} onChange={(e) => setLang(e.target.value)} data-testid="lang-select">
            {LANGUAGES.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
          </select>
          <div className="label">{t("Units")}</div>
          <select className="text-input load-select" value={unitPref()} onChange={(e) => setUnitPref(e.target.value)} data-testid="units-select">
            <option value="auto">{t("Automatic (by country)")} — {METRIC ? t("metric") : t("US gallons")}</option>
            <option value="us">{t("US: gallons, inches, pounds")}</option>
            <option value="metric">{t("Metric: liters, centimeters, kilograms")}</option>
          </select>
        </div>
        <button type="button" className="primary-btn secondary-btn" data-testid="account-sites" onClick={() => nav("/sites")}>
          <History size={16} />{t("Sites & History")}
        </button>
        <button type="button" className="primary-btn secondary-btn" data-testid="account-reviews" onClick={() => nav("/reviews")}>
          <Star size={16} />{t("Driver reviews")}
        </button>
        <BigTextRow t={t} />
        <WaterLimit t={t} />
        <AskDev />
        {user?.is_owner && <QuestionInbox />}
        {user?.is_owner && <ReviewInbox />}
        <Link to="/terms" className="gate-link" data-testid="account-terms-link">{t("Disclaimer & Terms")}</Link>
        <button type="button" className="ghost-btn danger-ghost" data-testid="logout-button"
          onClick={async () => { await signOut(); nav("/", { replace: true }); }}>
          <LogOut size={16} />{t("Sign out")}
        </button>
      </div>
    </div>
  );
}
